import NavigableValidator from "./navigableValidator";
import ObjectModelProperty from "../objectModelProperties/objectModelProperty";
import ObjectModel from "../objectModel";
import {INavigableValidatableModel} from "~/interfaces/navigableValidationInterfaces";
import {ErrorType} from "~/enums/ErrorType";
import {ValidationErrorMessage} from "~/enums/validationErrorMessage";
import {ObjectHelper} from "~/helpers/objectHelper";

type PropertyContainer = (ObjectModel & INavigableValidatableModel<ObjectModel>) | (ObjectModelProperty & INavigableValidatableModel<ObjectModelProperty>);

export default class ObjectModelPropertiesValidator extends NavigableValidator<PropertyContainer> {
  defaultMessage = ValidationErrorMessage.MustBePresent;
  defaultType = ErrorType.mustBePresent;

  protected _validate(model: PropertyContainer): void {
    const children = ObjectHelper.toArray(model.object_model_properties);
    for (const prop of children) {
      if (prop.validate) {
        prop.validate();
      }
    }
    this.errors = children.reduce((acc, child) => {
      if (child.validation) {
        acc.push(...child.validation.errors);
      }
      return acc;
    }, []);
  }

}